import React from 'react'
import Documents from '../modules/Documents/Documents'

const Index: React.FC = () => {
  return <Documents />
}

export default Index
